import { Button, InlineNotification } from 'carbon-components-react';
import { ArrowRight16, Subtract32 } from '@carbon/icons-react';
import './NoteDrawer.scss';
import awsimage from '../public/aws.png';
import ibmimage from '../public/ibm.png';
import { initUrxForm } from 'src/common/hooks/widgets/urxForm';
import { IBMLocale } from 'src/common/locale/mapValidLocale';
import { segmentsTracking } from 'src/common/lib/tracker';

export interface NoteDrawer {
  omniChannel: boolean;
  setUrxForm: React.Dispatch<React.SetStateAction<boolean>>;
  setOmniChannel: React.Dispatch<React.SetStateAction<boolean>>;
  moreinformation: boolean;
  bpName?: string;
  logo?: string;
  id: string;
  environment: string;
  instanceId: string;
  formId: string;
  urxlang: IBMLocale;
  bpid?: string;
  pageTitle: string;
  object: string;
  location: string;
  resultValue?: string;
  ctaValue?: string;
  action?: string;
  field?: string;
  tiles: string;
  setCookie: () => void;
  editionId: string;
  widgetTitle: string;
}

export default function NoteDrawer({
  id,
  omniChannel,
  setUrxForm,
  setOmniChannel,
  environment,
  urxlang,
  formId,
  instanceId,
  bpid,
  pageTitle,
  object,
  resultValue = '',
  ctaValue = '',
  action = '',
  field = '',
  location,
  tiles,
  setCookie,
  editionId,
  widgetTitle,
}: NoteDrawer) {
  const closeDrawer = () => {
    setOmniChannel(false);
    segmentsTracking('CTA Clicked', {
      pageTitle: pageTitle,
      object: object,
      resultValue: 'CTA clicked',
      CTA: 'ominichannel slider closed',
      location: location,
      action: action,
      field: field,
    });
  };

  return (
    <div id={id}>
      <div
        className={`widget-drawer-backdrop ${
          omniChannel ? 'opened' : 'closed'
        } widget-drawer-transition`}
        onClick={closeDrawer}
      ></div>
      <div
        className={`widget-drawer ${
          omniChannel ? 'opened' : 'closed'
        } widget-drawer-transition`}
      >
        <div className="widget-drawer-inner-container">
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
              <div className="widget-drawer-close-container">
                <Button
                  className="widget-drawer-close-btn"
                  kind="ghost"
                  renderIcon={Subtract32}
                  onClick={closeDrawer}
                ></Button>
              </div>
            </div>
          </div>
          <div className="widget-drawer-notes-container">
            <div className="bx--row">
              <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                <p className="slide_text widgetname">{widgetTitle}</p>
              </div>
              <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                <p className="page_sub_heading">Buy yours now!</p>
              </div>
              <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4 mt-02">
                <p className="page_body">
                  IBM {widgetTitle} SaaS Essentials offers flexible purchasing
                  options across various channels. Please choose the option that
                  aligns best with your business needs/requirements.
                </p>
              </div>

              <div className="cta-section">
                <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                  <img src={awsimage} />
                </div>
                <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4 cta">
                  <p className="page_body cta-text">
                    If you are already an AWS customer, buy through AWS to use
                    your existing credits
                  </p>
                  <Button
                    className="guardium-insights__bluehighlight"
                    kind="tertiary"
                    renderIcon={ArrowRight16}
                    id="request_btn"
                    onClick={() => {
                      segmentsTracking('CTA Clicked', {
                        pageTitle: pageTitle,
                        object: object,
                        resultValue: 'CTA clicked - Omnichannel',
                        CTA: 'aws marketplace - deeplink',
                        location: location,
                        action: action,
                        field: field,
                      });
                      window.open(
                        'https://aws.amazon.com/marketplace/pp/prodview-zw7rst7t566c2',
                        '_blank',
                      );
                    }}
                  >
                    Buy now on AWS
                  </Button>
                </div>
              </div>

              <div className="cta-section">
                <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                  {/* To be only visible till 31 July 2024 */}
                  {new Date().getUTCMonth() < 7 &&
                  new Date().getUTCFullYear() === 2024 ? (
                    <InlineNotification
                      kind="info"
                      role="onprem"
                      title=""
                      subtitle="Get a 30% discount on Guardium Insights Essentials
                      until July 31st 2024."
                      statusIconDescription="Premium Information"
                      hideCloseButton={true}
                    />
                  ) : null}
                </div>
                <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                  <img src={ibmimage} />
                </div>
                <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4 cta">
                  <p className="page_body cta-text">
                    Buy Guardium Essentials in a few simple clicks.
                  </p>
                  <Button
                    className="guardium-insights__bluehighlight"
                    kind="tertiary"
                    renderIcon={ArrowRight16}
                    id="request_btn"
                    onClick={() => {
                      segmentsTracking('CTA Clicked', {
                        pageTitle: pageTitle,
                        object: object,
                        resultValue: 'CTA clicked - Omnichannel',
                        CTA: 'ibm marketplace - deeplink',
                        location: location,
                        action: action,
                        field: field,
                      });
                      console.log(`Tiles - ${tiles}`);

                      setTimeout(async () => {
                        window.open(
                          `https://www.ibm.com/marketplace/purchase/configuration/en/us/checkout?editionID=EIDXX9VC&editionspromobannercta=true`,
                          '_blank',
                        );
                      }, 250);
                    }}
                  >
                    Buy now on ibm.com
                  </Button>
                </div>
              </div>

              <div className="cta-section">
                <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                  <p className="page_sub_heading">Request a quote</p>
                </div>
                <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4 mt-01 cta">
                  <p className="page_body cta-text">
                    Engage with our sales team to obtain answers to your
                    questions, discuss your specific requirement, and receive a
                    persolized quote
                  </p>
                  <Button
                    className="guardium-insights__bluehighlight"
                    renderIcon={ArrowRight16}
                    id="request_btn"
                    onClick={() => {
                      segmentsTracking('CTA Clicked', {
                        pageTitle: pageTitle,
                        object: object,
                        resultValue: 'CTA clicked - Omnichannel',
                        CTA: 'request a quote',
                        location: location,
                        action: action,
                        field: field,
                      });
                      initUrxForm(
                        environment,
                        instanceId,
                        formId,
                        urxlang as IBMLocale,
                        bpid,
                      );
                      setUrxForm(true);
                      setOmniChannel(false);
                      setCookie();
                    }}
                  >
                    Request a quote
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
